import styled from "styled-components";



import theme from "../../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    flex-direction: column; 

`;

export const Title = styled.h1`
    font-size: max(1.2vw, 10px);
    color: ${theme.colors.dark};

`;


export const Button = styled.button`
  margin: auto;

  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
`;